module.exports = __webpack_public_path__ + "img/mytarget-img-2.6e7a1cc8.jpg";